import * as React from 'react'

interface KnockLogoProps {
  height: string
  color?: string
  kColor?: string
  showKLetterOnly?: boolean
}

export const KnockLogo = ({
  color = '#182656',
  kColor = '#2362D6',
  showKLetterOnly = false,
  height,
}: KnockLogoProps) => {
  const viewBox = showKLetterOnly ? '82 0 29 29' : '0 0 111 29'

  return (
    <svg viewBox={viewBox} xmlns="http://www.w3.org/2000/svg" height={height} data-testid="icon-knocklogo">
      <title>Knock Logo</title>
      <g fill="none" fillRule="evenodd">
        {!showKLetterOnly && (
          <path
            d="M.9 2.5C.9.7 1.3.3 3.1.3h.7C5.6.3 6 .7 6 2.5v23.4c0 1.8-.4 2.2-2.2 2.2h-.6c-1.8 0-2.2-.4-2.2-2.2V2.5H.9zm11.4 7.4c1.1-1.4 1.8-1.7 3.6-1.7h2c1.8 0 1.9.3.8 1.7l-5.2 6.4c-.3.4-.8.8-.8 1.3 0 .4.4 1 .7 1.3l6.1 7.5c1.1 1.4 1 1.8-.8 1.8h-2c-1.8 0-2.5-.4-3.6-1.8l-4-5c-1.2-1.5-1.6-2.6-1.6-3.9 0-1.4.4-2.2 1.6-3.5l3.2-4.1zm15.8 16c0 1.8-.4 2.2-2.2 2.2h-.8c-1.8 0-2.2-.4-2.2-2.2V15.8c0-5.2 3.1-8.1 9.1-8.1 6.3 0 9 2.7 9 8.1v10.1c0 1.8-.4 2.2-2.2 2.2H38c-1.8 0-2.2-.4-2.2-2.2V15.8c0-2-.5-3.1-3.8-3.1s-3.9 1.1-3.9 3.1v10.1zm16.4-6.1v-3.2c0-5.7 3.3-8.9 9.6-8.9 6.5 0 9.5 3 9.5 8.9v3.2c0 5.7-3.3 8.9-9.5 8.9-6.6-.1-9.6-3-9.6-8.9zm13.8-3.2c0-2.6-.7-3.9-4.3-3.9-3.6 0-4.3 1.4-4.3 3.9v3.2c0 2.6.8 3.9 4.3 3.9s4.3-1.4 4.3-3.9v-3.2zm8.4-.3c0-5.1 3.2-8.5 9.5-8.5 1.2 0 2.1.2 2.6.3 1.7.4 2.1.9 2.1 2.7v.4c0 1.8-.4 2.2-2.1 1.8-.6-.2-1.4-.3-2.5-.3-3.1 0-4.4.8-4.4 3.7V20c0 2.9 1.4 3.8 4.7 3.8.9 0 1.8-.1 2.4-.2 1.8-.3 2.2 0 2.2 1.8v.4c0 1.8-.4 2.3-2.2 2.6-.5.1-1.6.3-2.7.3-6.8 0-9.7-3.1-9.7-8.5v-3.9h.1z"
            fill={color}
          />
        )}
        <path
          d="M87.1.2h-.7c-1.8 0-2.2.4-2.2 2.2v23.4c0 1.8.4 2.2 2.2 2.2h.7c1.8 0 2.2-.4 2.2-2.2V2.5C89.4.7 88.9.2 87.1.2zm15.6 26.2l-6.1-7.5c-.3-.3-.7-.8-.7-1.3s.4-1 .8-1.3l5.2-6.4c1.1-1.4 1-1.7-.8-1.7h-2c-1.8 0-2.5.4-3.6 1.7l-3.2 4c-1.2 1.4-1.6 2.2-1.6 3.5 0 1.4.4 2.4 1.6 3.9l4 5c1.1 1.4 1.8 1.8 3.6 1.8h2c1.8 0 2-.3.8-1.7zm7.5-6.6c0 .9-.7 1.6-1.6 1.6h-3.2c-.9 0-1.6-.7-1.6-1.6v-3.2c0-.9.7-1.6 1.6-1.6h3.2c.9 0 1.6.7 1.6 1.6v3.2z"
          fill={kColor}
        />
      </g>
    </svg>
  )
}
